import { makeNonNullNumberSchema, makeNumberSchema, makeStrictNumberSchema } from '#schemas/general/number.ts';

export const INVALID_PORT = 'Invalid port number';
export const MIN_PORT_ERR = 'Please specify a port number greater than 0';
export const MIN_PORT_ERR_ALLOW_ZERO = 'Please specify a port number of 0 or greater';
export const MAX_PORT_ERR = 'Port cannot be higher than 65535';

export const portSchema = makeNumberSchema(
  { min: { value: 1, message: MIN_PORT_ERR }, max: { value: 65535, message: MAX_PORT_ERR } },
  { invalid_type_error: INVALID_PORT }
);

export const portSchemaRequired = makeNonNullNumberSchema(
  { min: { value: 1, message: MIN_PORT_ERR }, max: { value: 65535, message: MAX_PORT_ERR } },
  {
    errorMap: (issue, ctx) => {
      if (ctx.data === null) {
        return { message: MIN_PORT_ERR };
      }
      return { message: INVALID_PORT };
    },
  }
);

export const portSchemaStrict = makeStrictNumberSchema({
  min: { value: 1, message: MIN_PORT_ERR },
  max: { value: 65535, message: MAX_PORT_ERR },
  required: { message: MIN_PORT_ERR },
});

export const portSchemaAllowZeroRequired = makeNonNullNumberSchema(
  { min: { value: 0, message: MIN_PORT_ERR_ALLOW_ZERO }, max: { value: 65535, message: MAX_PORT_ERR } },
  {
    errorMap: (issue, ctx) => {
      if (ctx.data === null) {
        return { message: MIN_PORT_ERR_ALLOW_ZERO };
      }
      return { message: INVALID_PORT };
    },
  }
);
